// assets/cart-discount.js

document.addEventListener('DOMContentLoaded', () => {
  bindDiscountEvents();
  rebindDiscountRemove();
});
function debounce(fn, wait = 600) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}
async function validateCode(code) {
  if (!code) return { valid: false, checked: false };

  try {
    // Clear existing discounts
    await fetch('/discount/clear?redirect=/cart', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    // Apply discount
    await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    // Fetch updated cart
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(r => r.json());

    const normalizedCode = code.toLowerCase();

    const isApplicable =
      Array.isArray(cart.discount_codes) &&
      cart.discount_codes.some(dc =>
        dc.code?.toLowerCase() === normalizedCode &&
        dc.applicable === true
      );

    return {
      valid: isApplicable,
      checked: true
    };

  } catch (error) {
    console.error('Discount validation error', error);
    return { valid: false, applicable: false, checked: true };
  }
}


function bindDiscountEvents() {
  const controls = [
    { inputSelector: '#Cart-discount-drawer', messageSelector: '#CartDrawer-DiscountMessage', checkoutSelector: '#CartDrawer-Checkout' },
  ];

  controls.forEach(({ inputSelector, messageSelector, checkoutSelector }) => {
    const input = document.querySelector(inputSelector);
    const msgEl = document.querySelector(messageSelector);
    const checkoutBtn = document.querySelector(checkoutSelector);

    if (!input || !msgEl) return;

    let lastCode = '';
    let lastValid = false;

    const showMessage = (text, color = '') => {
      msgEl.innerHTML = text;
      msgEl.style.color = color;
    };

    function tDiscount(key, params = {}) {
      if (!window.CartDiscountI18n || !window.CartDiscountI18n[key]) return '';

      let msg = window.CartDiscountI18n[key];

      Object.keys(params).forEach(k => {
        msg = msg.replace(`{{ ${k} }}`, params[k]);
      });

      return msg;
    }

    const doValidate = debounce(async () => {
      const code = input.value.trim();
      if (!code) {
        lastCode = '';
        lastValid = false;
        showMessage('');
        return;
      }
      // showMessage('Checking code…', '');
      showMessage(tDiscount('checking'));

      const { valid } = await validateCode(code);
      lastCode = code;
      lastValid = valid;
      if (valid) {
        // showMessage(`✓ Discount "${code}" will apply at checkout.`, 'green');
        showMessage(
          tDiscount('success', { code }),
          'green'
        );

        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const newContent = doc.querySelector("#CartDrawer .drawer__inner");
            if (newContent) {
              document.querySelector("#CartDrawer .drawer__inner").innerHTML = newContent.innerHTML;
            }
          }).finally(() => {
            updateProgressBar();
            loadCartDrawerProducts();
            bindDiscountEvents();
            rebindDiscountRemove();
          });
      } else {
        // showMessage(`✗ Discount "${code}" is invalid or expired.`, 'red');
        showMessage(
          tDiscount('error', { code }),
          'red'
        );

      }
    }, 600);

    input.addEventListener('input', doValidate);

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', async (e) => {
        const code = input.value.trim();
        if (!code) return;
        e.preventDefault();
        if (code === lastCode && lastValid) {
          window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
          return;
        }
        // showMessage('Checking code before checkout…', '');
        showMessage(tDiscount('checking'));

        const { valid } = await validateCode(code);
        lastCode = code;
        lastValid = valid;
        if (valid) {
          window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
        } else {
          // showMessage(`✗ Discount "${code}" is invalid or expired.`, 'red');
          showMessage(
            tDiscount('error', { code }),
            'red'
          );
          input.focus();
        }
      });
    }
  });
}

function rebindDiscountRemove() {
  document.querySelector('.discounts__remove')?.addEventListener('click', removeDiscountCode);
}

async function removeDiscountCode() {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: '' })
  })
  .then(response => response.json())
  .then(data => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newContent = doc.querySelector("#CartDrawer .drawer__inner");
        if (newContent) {
          document.querySelector("#CartDrawer .drawer__inner").innerHTML = newContent.innerHTML;
        }
      }).finally(() => {
        updateProgressBar();
        loadCartDrawerProducts();
        bindDiscountEvents();
        rebindDiscountRemove();
      });
  });
}